// extracted by mini-css-extract-plugin
export var accordionItemContainer = "styles-module--accordionItemContainer--d8755";
export var answer = "styles-module--answer--9f891";
export var answerContainer = "styles-module--answerContainer--43642";
export var open = "styles-module--open--2df70";
export var openBlock = "styles-module--openBlock--a63b7";
export var openIcon = "styles-module--openIcon--f11ab";
export var question = "styles-module--question--197e9";
export var questionContainer = "styles-module--questionContainer--53fbd";